import React from 'react';
import './label-above.scss';

/**
 * Label above child input
 */
export const LabelAbove = React.forwardRef<
    HTMLDivElement,
    {
        label: string;
        forID?: string;
        onClick?: () => void;
        className?: string;
        children: React.ReactNode;
    }
>(({ label, onClick, forID, className, children }, ref) => (
    <div ref={ref} className={`estimator-label-above ${className}`}>
        <label onClick={onClick} htmlFor={forID}>
            {label}
        </label>
        {children}
    </div>
));
